import { config, msg } from 'api';
import { setErrorMessage } from 'apps/notifications/actions/notifications';
import { wa, pageEventTypes } from 'apps/analytics';
import errorHandler from 'lib/utils/errorHandler';

export const SET_ADDITIONAL_BAGS_PREFERENCE = 'SET_ADDITIONAL_BAG_PREFERENCE';
export const USE_ADDITIONAL_BAGS_TO_SEPARATE_RAW_FOOD_FIELD_NAME = 'USE_ADDITIONAL_BAGS_TO_SEPARATE_RAW_FOOD';

export function setAdditionalBagsPreference(useAdditionalBags) {
  return {
    type: SET_ADDITIONAL_BAGS_PREFERENCE,
    useAdditionalBags,
  };
}

export function saveAdditionalBagsPreference(useAdditionalBags) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/delivery-preferences`,
      {
        body: JSON.stringify({
          rawFoodSegregationEnabled: useAdditionalBags,
        }),
      })
      .then(() => {
        wa.triggerPageEvent(
          pageEventTypes.DELIVERY_PREFERENCES_SUCCESS_NOTIFICATION_DISPLAYED,
          { [USE_ADDITIONAL_BAGS_TO_SEPARATE_RAW_FOOD_FIELD_NAME]: useAdditionalBags }
        );
        dispatch(setAdditionalBagsPreference(useAdditionalBags));
        return true;
      })
      .catch(() => {
        wa.triggerPageEvent(
          pageEventTypes.DELIVERY_PREFERENCES_ERROR_NOTIFICATION_DISPLAYED,
          { [USE_ADDITIONAL_BAGS_TO_SEPARATE_RAW_FOOD_FIELD_NAME]: useAdditionalBags }
        );
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}

export function getAdditionalBagsPreference() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/delivery-preferences`)
      .then(response =>
        dispatch(setAdditionalBagsPreference(response.rawFoodSegregationEnabled))
      )
      .catch(errorHandler);
}

